import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../../store/authStore';

interface ErrorAlertProps {
  message: string | null;
  onClose?: () => void;
  autoClose?: boolean;
  autoCloseTime?: number;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ 
  message, 
  onClose,
  autoClose = true,
  autoCloseTime = 5000
}) => {
  const [visible, setVisible] = useState(!!message);
  const navigate = useNavigate();
  const { logout } = useAuthStore();
  
  // Check if error is related to authentication or permissions
  const isAuthError = message?.toLowerCase().includes('forbidden') || 
                     message?.toLowerCase().includes('unauthorized') ||
                     message?.toLowerCase().includes('permission') ||
                     message?.toLowerCase().includes('access denied') ||
                     message?.toLowerCase().includes('403') ||
                     message?.toLowerCase().includes('401');
  
  useEffect(() => {
    setVisible(!!message);
    
    // Auto-close the alert after the specified time
    if (autoClose && message && !isAuthError) {
      const timer = setTimeout(() => {
        handleClose();
      }, autoCloseTime);
      
      return () => clearTimeout(timer);
    }
  }, [message, autoClose, autoCloseTime, isAuthError]);
  
  const handleClose = () => {
    setVisible(false);
    if (onClose) {
      onClose();
    }
  };
  
  const handleLogout = () => {
    logout();
    navigate('/login');
    handleClose();
  };
  
  if (!message || !visible) {
    return null;
  }
  
  return (
    <div className="error-alert">
      <div className="error-alert-content">
        <div className="error-alert-icon">⚠️</div>
        <div className="error-alert-message">{message}</div>
        {isAuthError && (
          <button className="error-alert-action" onClick={handleLogout}>Logout</button>
        )}
        <button className="error-alert-close" onClick={handleClose}>×</button>
      </div>
    </div>
  );
};

export default ErrorAlert; 